/**
 * Normalise une date en YYYY-MM-DD (jour calendrier, pas UTC).
 */
export function toCalendarYmd(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const plain = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (plain) return plain[0];
  const d = value instanceof Date ? value : new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
